import React from 'react'
import './spinner.css'
import config from '../../config'


const Spinner = () => {
  const themeState = localStorage.getItem('theme') || config.THEMES_MODES.LIGHT
  const {
    primary,
    secondary,
    dotPrimary,
    dotSecondary,
    overlayFallback,
    overlay,
  } = config.SPINNER_COLORS[themeState] 

  const spinnerStyle = {
    '--spinner-primary': primary,
    '--spinner-secondary': secondary,
    '--spinner-dot-primary': dotPrimary,
    '--spinner-dot-secondary': dotSecondary,
    '--spinner-overlay-fallback': overlayFallback,
    '--spinner-overlay': overlay,
  }

  return (
    <div className="modal-spinner" style={spinnerStyle}>
        <div className="lds-css">
            <div className="lds-double-ring">
                <div />
                <div />
            </div>
        </div>
    </div>
  );
};

export default Spinner;
